import React from "react";
import { Drawer, List, ListItem, Box } from "@mui/material";
import NavLink from "./NavLink";
import { MobileDrawerProps } from "../@types/types";

const MobileDrawer: React.FC<MobileDrawerProps> = ({
  open,
  onClose,
  pages,
}) => {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        "& .MuiDrawer-paper": {
          width: "65%",
          bgcolor: "background.paper",
          boxShadow: "1px 0px 8px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box onClick={onClose} sx={{ textAlign: "center" }}>
        <List>
          {pages.map((page, index) => (
            <ListItem key={index} component="a" href={page.pageURL}>
              <NavLink page={page} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
